import { LAYOUT_SECTION } from '@adalo/constants'
import { assetURL } from 'utils/assets'
import { FormattedSection, formatPrimaryTags } from 'utils/layoutSections'
import { UserState, getCurrentUser } from 'ducks/users'
import { StoreState, getPrebuiltLayoutSections } from 'ducks/layoutSections'
import { PrebuiltBuilderContentPlatformTarget } from 'ducks/layoutSections/types'
import { DefaultRootState } from 'react-redux'
import { App } from 'ducks/apps'
import SectionImage from '../icons/layout-section.png'
import { FormattedFeatureTemplate } from './featureHelpers'
import { Component, Library } from './componentHelpers'

interface Props extends FormattedSection {
  handleSelect: (
    value: Record<string, unknown>,
    position: [number, number]
  ) => void
}

export function isFormattedSection(
  item: Component | Library | FormattedSection | FormattedFeatureTemplate
): item is FormattedSection {
  return (item as FormattedSection).primaryTags !== undefined
}

export const getFormattedSections = (
  state: DefaultRootState,
  app: App
): FormattedSection[] => {
  const user = getCurrentUser(state as UserState)
  const adaloAdmin = user?.admin || false

  const { layoutMode = 'both' } = app?.webSettings || {}
  const mobileOnly = layoutMode === 'mobile'

  const opts = {
    platformTarget: layoutMode as PrebuiltBuilderContentPlatformTarget,
    includeUnlisted: adaloAdmin,
  }

  const prebuiltLayoutSections = getPrebuiltLayoutSections(
    state as StoreState,
    opts
  )

  const formattedSections: FormattedSection[] = prebuiltLayoutSections.map(
    section => {
      return {
        label: section.name,
        image: mobileOnly
          ? section.mobileThumbnail
          : section.responsiveThumbnail,
        ...section,
      }
    }
  )

  return formattedSections
}

export const renderSectionOption = ({
  image,
  label,
  body,
  primaryTags,
  handleSelect,
}: Props): JSX.Element => {
  const source = image ? assetURL(image) : SectionImage
  const tags = formatPrimaryTags(primaryTags)
  const value = { type: LAYOUT_SECTION, options: body }

  return (
    <div className="prebuilt-section-item">
      <div
        role="button"
        tabIndex={0}
        onMouseDown={(e: MouseEvent) =>
          handleSelect(value, [e.clientX, e.clientY])
        }
      >
        <img
          className="prebuilt-section-image"
          src={source}
          alt={label}
          style={{
            width: '100%',
            border: '1px solid gray',
            padding: '3px',
            borderRadius: '7px',
          }}
          draggable={false}
        />
      </div>
      <div className="prebuilt-section-tags-container">
        {tags.map(tag => (
          <p className="prebuilt-section-tag">{tag}</p>
        ))}
      </div>
    </div>
  )
}
